import { Button, ButtonGroup } from '@timelyapp/react';
import RichTooltip from 'components/RichTooltip';
import KeyboardShortcutTooltip from 'components/tooltips/KeyboardShortcutTooltip';
import React, { useCallback } from 'react';
import FontAwesome from 'react-fontawesome';
import { getOS, OS } from 'utils/os-detection';
import styles from './GanttChart.module.scss';
import type { GanttInteractionMode, GanttZoomLevelCategory } from './gantt-internal-types';

interface Props {
  mode: GanttInteractionMode;
  onSetMode: (mode: GanttInteractionMode) => void;
  zoomLevelCategory: GanttZoomLevelCategory;
  onZoomLevelCategoryChange: (zoomLevelCategory: GanttZoomLevelCategory) => void;
}

const GanttChartFloatingToolbar: React.FC<Props> = props => {
  const { mode, onSetMode, zoomLevelCategory, onZoomLevelCategoryChange } = props;
  const handleClickPanMode = useCallback(() => {
    onSetMode(mode === 'pan' ? 'default' : 'pan');
  }, [mode, onSetMode]);
  return (
    <div className={styles.floatingToolbar}>
      <div className={styles.group}>
        <RichTooltip position="top" fixed tooltip={PanModeTooltip}>
          <Button
            onClick={handleClickPanMode}
            isActive={mode === 'pan'}
            className={styles.modeButton}
            size="small"
          >
            <FontAwesome name="hand-paper" />
          </Button>
        </RichTooltip>
      </div>
      <div className={styles.group}>
        <RichTooltip position="top" fixed tooltip={ZoomLevelsTooltip}>
          <ButtonGroup
            onChange={value => onZoomLevelCategoryChange(value)}
            activeValue={zoomLevelCategory}
            options={zoomLevelOptions}
            size="small"
          />
        </RichTooltip>
      </div>
    </div>
  );
};
export default GanttChartFloatingToolbar;

const PanModeTooltip = () => (
  <KeyboardShortcutTooltip title="Pan mode - drag to move around" shortcut="Hold space" />
);

const ZoomLevelsTooltip = () => {
  const modifier = getOS() === OS.Mac ? 'command' : 'ctrl';
  return <KeyboardShortcutTooltip title="Zoom level" shortcut={`${modifier} + scroll`} />;
};

const zoomLevelOptions = [
  {
    value: 'day' as const,
    label: 'Day',
  },
  {
    value: 'week' as const,
    label: 'Week',
  },
  {
    value: 'month' as const,
    label: 'Month',
  },
];
